import { IconComponent } from '@schleegleixner/react-icons-package'
import IconStadtkarte from '@/components/Icons/Stadtkarte'
import {
  ArrowLongLeftIcon as ArrowLeft,
  ArrowLongRightIcon as ArrowRight,
} from '@heroicons/react/24/outline'
import { ActionFieldsIconMap } from '@/mapping/dimensionMapping'

const iconMap: Record<string, IconComponent> = {
  stadtkarte: IconStadtkarte,
  arrow_right: ArrowRight,
  arrow_left: ArrowLeft,
}

Object.assign(iconMap, ActionFieldsIconMap)

export default iconMap
